import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import * as styles from './fallback.styles';

export const Fallback = () => {
  const { t } = useTranslation();
  const handleReloadPage = () => {
    location.reload();
  };

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img
          src="https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_white,d_photoiscoming.png/v1/other/navigation-microfronts/pdp/calculator_remote_error.webp/file.png"
          loading="lazy"
          alt={t('calculator.fallback.loading-error')}
        />
      </div>
      <div className={styles.title}>
        <Typography variant="m" size="body_accent" color="text-primary">
          {t('calculator.fallback.loading-error')}
        </Typography>
      </div>
      <div className={styles.description}>
        <Typography variant="m" size="body_short" color="text-primary">
          {t('calculator.fallback.try-reload')}
        </Typography>
      </div>
      <RegularButton
        data-testid="calculate-fallback-reload-button"
        rounded
        size="l"
        variant="secondary"
        onClick={handleReloadPage}
      >
        {t('calculator.fallback.reload')}
      </RegularButton>
    </div>
  );
};
